export const KEY_WAY_STORE_NAME = 'keyWayStoreName'
export const INIT_FIELDS_NAME = 'initFields'